export const formatCurrency = ({
  amount,
  currency,
  locale = "en-US",
}) => {
  const numericAmount = Number(amount || 0);
  const currencyCode = String(currency || "USD").toUpperCase();

  try {
    return new Intl.NumberFormat(locale, {
      style: "currency",
      currency: currencyCode,
      maximumFractionDigits: 2,
    }).format(numericAmount);
  } catch {
    return `${currencyCode} ${numericAmount.toLocaleString()}`;
  }
};
